/**
 * @desc 上架首页横幅
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type PublishBannerParameter = {
  id?: string
}

const method = 'PUT'
const url = '/content/operation/banner/publish'

export const publishBannerApi = (
  params?: PublishBannerParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    params,
    ...config
  })
}

publishBannerApi.method = method
publishBannerApi.url = url
